
//Import asset file(s) used by this module.
import AbstractInstaller from '../../../shared/src/ranj/app/core/AbstractInstaller.js';
import AppInstaller from '../../../shared/src/ranj/app/core/AppInstaller.js';
import AppModel from '../../../shared/src/ranj/app/core/AppModel.js';
import ContextEvent from "../../../shared/src/ranj/app/core/ContextEvent";
import ExitGameCommand from '../../../shared/src/ranj/app/core/ExitGameCommand.js';
import GameEvent from '../../../shared/src/ranj/app/core/GameEvent.js';
import LoadStartupAssetsTask from '../../../shared/src/ranj/app/startup/LoadStartupAssetsTask.js';
import SkinKeys from '../../../shared/src/ranj/app/ui/SkinKeys.js';
import InitPlatformAPIServiceTask from '../../../shared/src/ranj/equalture/platform/InitPlatformAPIServiceTask.js';
import SaveCommand from '../../../shared/src/ranj/equalture/savegame/SaveCommand.js';
import SaveEvent from '../../../shared/src/ranj/equalture/savegame/SaveEvent.js';
import InitLanguageTask from '../../../shared/src/ranj/equalture/startup/InitLanguageTask.js';
import ShowSplashScreenTask from '../../../shared/src/ranj/equalture/startup/ShowSplashScreenTask.js';
import StartGameCommand from './accuracy/controller/StartGameCommand.js';
import InitAccuracyGameTask from './accuracy/core/InitAccuracyGameTask.js';
import GameConfig from './accuracy/model/GameConfig.js';
import GameModel from './accuracy/model/GameModel.js';
import SaveModel from './accuracy/model/SaveModel.js';
import TrackingController from './accuracy/model/TrackingController.js';
import EndScreenMediator from './accuracy/view/EndScreenMediator.js';
import GameScreenMediator from './accuracy/view/GameScreenMediator.js';
import SplashLoadScreenMediator from './accuracy/view/SplashLoadScreenMediator.js';
import TutorialOverlayMediator from './accuracy/view/TutorialOverlayMediator.js';

import '../../assets/skins/MainAssets.js';
import '../../assets/skins/SplashAssets.js';
import '../../assets/skins/LevelAssets.js';

import '../../../shared/lib/html5-software-library/src/ranj/util/CreateJSExtensions';
import SaveController from './accuracy/controller/SaveController.js';
import GateKeeperOverlayMediator from './accuracy/view/GateKeeperOverlayMediator.js';
import GameElementSkinFactory from './accuracy/view/GameElementSkinFactory.js';


export default class MinigameInstaller extends AbstractInstaller {

    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "SplashAssets");
        this._addAssetGroupsToList(AppInstaller.STARTUP_ASSET_GROUPS, "sounds", "common", "MainAssets", "LevelAssets");


        commands.add(ContextEvent.START_GAME, StartGameCommand);
        commands.add(GameEvent.EXIT, ExitGameCommand);

        injector.mapClass("appModel", AppModel, true);
        injector.mapClass("gameModel", GameModel, true);
        injector.mapClass("trackingController", TrackingController, true);
        injector.mapClass("gameConfig", GameConfig, true);
        injector.mapValue("gameAssets", lib.MainAssets);
        injector.mapValue("levelAssets", lib.LevelAssets);

        injector.mapClass("gameElementSkinFactory", GameElementSkinFactory, true);

        injector.mapValue("saveController", injector.createInstance(SaveController));
        injector.mapClass("saveModel", SaveModel, true);
        commands.add(SaveEvent.SAVE, SaveCommand);
        commands.add(SaveEvent.CLEAR, SaveCommand);

        this._addAssetGroupsToList(AppInstaller.PRELOAD_ASSET_GROUPS, "preload");
                
        this._addStartupTask(InitPlatformAPIServiceTask, "InitPlatformAPIServiceTask", 5);
        this._addStartupTask(InitAccuracyGameTask, "InitAccuracyGameTask", 0);
        this._addStartupTask(InitLanguageTask, "InitLanguageTask", 0, ["InitPlatformAPIServiceTask"]);
        this._addStartupTask(ShowSplashScreenTask, "ShowSplashScreenTask", 0);
        this._addStartupTask(LoadStartupAssetsTask, "LoadStartupAssetsTask", 30, ["InitLanguageTask"]);

        SkinKeys.SPLASH_LOAD_SCREEN_SKIN = this._mapMediator(SplashLoadScreenMediator, lib.SplashAssets.SplashLoadScreenSkin);
        SkinKeys.GAME_SCREEN = this._mapMediator(GameScreenMediator, lib.MainAssets.GameScreenSkin);
        SkinKeys.END_SCREEN = this._mapMediator(EndScreenMediator, lib.MainAssets.EndScreenSkin);
        SkinKeys.TUTORIAL_OVERLAY = this._mapMediator(TutorialOverlayMediator, lib.MainAssets.TutorialOverlaySkin);
        SkinKeys.GATEKEEPER_OVERLAY = this._mapMediator(GateKeeperOverlayMediator, lib.MainAssets.GateKeeperOverlaySkin);
    }

};
